import React from 'react';
const Logo = () => {
  return (
    <svg
      version="1.1"
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 125 40"
      width="125"
      height="40"
    >
      <g>
        <path
          fill="currentColor"
          d="M30,40v-8.7H14.5l8.7-8.7c0.8-0.6,1.2-1.5,1.2-2.6c0-1-0.5-1.9-1.2-2.5l-8.8-8.9H30V0H5.4c0,0-0.1,0-0.1,0
		C2.6,0,0.4,2.2,0.4,4.9C0.4,6.3,1,7.5,2,8.4l0,0L13.3,20L2,31.7l0,0c-0.9,0.9-1.4,2.1-1.4,3.4c0,2.7,2.2,4.9,4.9,4.9
		c0.2,0,0.3,0,0.5,0H30z"
        />
        <path
          fill="currentColor"
          d="M34.3,9.1l18.3,10.6L34.4,30.8l0,9.2l28-15.8l0,0c1.6-0.9,2.7-2.6,2.7-4.5c0-2-1.2-3.7-2.9-4.5L34.3,0
		L34.3,9.1z"
        />
      </g>
    </svg>
  );
};
export default Logo;



// WEBPACK FOOTER //
// ./src/svg/logo.jsx